import { Component, OnInit, Input } from '@angular/core';
import { FeeScheduleService } from '../services/fee-schedule.service';
import { MessagingService } from '../../../services/messaging.service';
import { Globals } from '../../../globals';
import {IconRegistryService} from '../../../utilities/icon-registry.service';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {FeeScheduleMyItemsDataModel} from '../../../models/fee-schedule/fee-schedule-my-items.model';
import {InsuranceExplosionDataModel} from '../../../models/insurance/insurance-explosion-data.model';
import {FeeScheduleListViewDataModel} from '../models/fee-schedule-list-view.model';

@Component({
  selector: 'app-fee-schedule-main',
  templateUrl: './fee-schedule-main.component.html',
  styleUrls: ['./fee-schedule-main.component.css']
})
export class FeeScheduleMainComponent implements OnInit {

  @Input() cfgTDOUserID: string;
  @Input() TDOCID: number;
  @Input() doctorId: string;

  organizationID: string;
  selectedDocFeeScheduleID: string;
  selectedFeeScheduleID: string;
  feeScheduleList: FeeScheduleDataModel[];
  feeScheduleMyItems: FeeScheduleMyItemsDataModel[] = [];
  dataExplosions: InsuranceExplosionDataModel[] = [];
  activeFeeSchedule: FeeScheduleDataModel;
  isLoading: boolean = false;
  messagingSubscription: any;

  constructor(
    private messagingService: MessagingService,
    private feeScheduleService: FeeScheduleService,
    globals: Globals,
    iconRegistryService: IconRegistryService) {
    iconRegistryService.registerIcon('fee-schedule', 'assets/Images/navbar-icons/fee-schedule.svg');
  }

  ngOnInit() {
    this.messagingSubscription = this.messagingService.componentMessageCall.subscribe(
      response => {

        /*if (response.event === 'FEE_SCHEDULE_LOADING') {
          this.isLoading = response.data.isLoading;
        }*/

        if (response.event === 'INIT_FEE_SCHEDULE') {
          this.init();
        }

        if (response.event === 'SELECTED_FEE_SCHEDULE_CHANGES') {

          if (response.data.feeSchedule) {

            // MESSAGE BELOW TRIGGERS MULTIPLE ONIT calls in fee-schedule-item-list.ts
            this.activeFeeSchedule = response.data.feeSchedule;
          }
        }

        if (response.event === 'FETCH_EXPLOSIONS') {
          this.fetchExplosions(this.TDOCID)
            .then((results: any) => {
              this.dataExplosions = results;
              this.messagingService.sendComponentMessage('REFRESH_EXPLOSIONS', { dataExplosions: this.dataExplosions });
            });
        }
      }
    );

    this.init();
  }

  init() {
    const currentUser: any = JSON.parse(localStorage.getItem('storedUser'));
    this.TDOCID = currentUser.TDOCID;
    this.cfgTDOUserID = currentUser.authdata.userid;
    //this.isLoading = true;

    // const initPromises = [
    //   this.fetchAllSchedules(),
    //   this.fetchMyFeeScheduleItems(this.cfgTDOUserID),
    //   this.fetchExplosions(this.TDOCID),
    // ];

    // Promise.all(initPromises).then((results: any) => {
    //   this.feeScheduleList = results[0];
    //   this.feeScheduleMyItems = results[1];
    //   this.dataExplosions = results[2];
    //
    //   if (this.feeScheduleList) {
    //     this.isLoading = false;
    //   }
    // }, err => {
    //   this.isLoading = false;
    //   console.log(err);
    // });
  }

  fetchExplosions(TDOCID: number) {
    const promise = new Promise((resolve, reject) => {
      this.feeScheduleService.getExplosions(TDOCID)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  fetchMyFeeScheduleItems(UserID: string) {
    const promise = new Promise((resolve, reject) => {
      this.feeScheduleService.getMyScheduleItems(UserID).subscribe(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      );
    });
    return promise;
  }

  setSelectedSchedule(feeScheduleItem: FeeScheduleListViewDataModel) {
    this.selectedFeeScheduleID = feeScheduleItem.FeeScheduleID;
    this.organizationID = feeScheduleItem.OrganizationID;
    this.activeFeeSchedule = feeScheduleItem;
  }

  setSelectedDocSchedule(docFeeScheduleID) {
    this.selectedDocFeeScheduleID = docFeeScheduleID;
  }

  fetchAllSchedules() {
    const promise = new Promise((resolve, reject) => {

      if (this.doctorId) {
        this.feeScheduleService.getAllFeeSchedulesByDoctorID(this.doctorId)
          .subscribe(response => {
            resolve(response);
          }, err => {
            reject(err);
          });
      } else {
        this.feeScheduleService.getAllFeeSchedules()
          .subscribe(response => {
            resolve(response);
          }, err => {
            reject(err);
          });
      }
    });

    return promise;
  }
}
